import { ComponentProps } from 'react';

import { PencilSvg } from 'components/svgs/PencilSvg';

import { RowButton } from './RowButton';

interface EditButtonProps extends ComponentProps<typeof RowButton> {
  testId?: string;
  gtm?: string;
}

export const EditButton = ({
  onClick,
  icon,
  testId = 'edit-button',
  gtm,
  ...buttonProps
}: EditButtonProps) => {
  return (
    <RowButton
      onClick={onClick}
      icon={icon || <PencilSvg />}
      testId={testId}
      gtm={gtm}
      {...buttonProps}
    />
  );
};
